import { render, staticRenderFns } from "./AddUpdateAccount.vue?vue&type=template&id=d95c6728&"
import script from "./AddUpdateAccount.vue?vue&type=script&lang=js&"
export * from "./AddUpdateAccount.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports